import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import authorsTableData from "./table-data";

// Redux and API
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../../redux/Reducers/GlobalReducer/globalSlice";
import { useSnackbarContext } from "components/SnackBarContext";
import { API_FAIL_MESSAGE, SUCCESS } from "constants/apiConstants";
import { API_ENDPOINTS } from "constants/apiConstants";
import api from "services/api";

function BuildStyles() {
  const [tableData, setTableData] = useState([]);
  const [open, setOpen] = useState(false);
  const [newTitle, setNewTitle] = useState("");
  const [newDescription, setNewDescription] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [editingItem, setEditingItem] = useState(null);
  const auth = useSelector((state) => state.auth);
  const { IsLoginData } = auth;
  const tableName = "Build Styles";
  const dispatch = useDispatch();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbarContext();

  useEffect(() => {
    getTableData();
  }, []);

  const getTableData = async () => {
    try {
      dispatch(setLoading(true));
      const response = await api.get(API_ENDPOINTS.GET_BUILDSTYLES);
      console.log(`GET ${tableName}`, response);
      dispatch(setLoading(false));
      const { status, data, message } = response.data;
      if (status === SUCCESS) {
        setTableData(data);
      } else {
        showErrorSnackbar(message);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Get ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };

  const handleAddNew = () => {
    setEditingItem(null);
    setNewTitle("");
    setNewDescription("");
    setIsActive(true);
    setOpen(true);
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setNewTitle(item.stylename || "");
    setNewDescription(item.description || "");
    setIsActive(!!item.isactive);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setNewTitle("");
    setNewDescription("");
    setIsActive(true);
    setEditingItem(null);
  };

  const handleSubmit = async () => {
    const payload = {
      user_id: IsLoginData.idUser,
      stylename: newTitle,
      // description: newDescription,
      isactive: isActive ? 1 : 0,
    };

    try {
      dispatch(setLoading(true));
      let response;
      if (editingItem) {
        payload.buildstyle_id = editingItem.buildstyle_id;
        response = await api.post(API_ENDPOINTS.UPDATE_BUILDSTYLE, payload);
      } else {
        response = await api.post(API_ENDPOINTS.CREATE_BUILDSTYLE, payload);
      }
      const { status, message } = response.data;
      dispatch(setLoading(false));

      if (status === SUCCESS) {
        showSuccessSnackbar(
          message ||
            (editingItem
              ? `Updated ${tableName} successfully`
              : `Created ${tableName} successfully`)
        );
        handleClose();
        getTableData();
      } else {
        showErrorSnackbar(message || API_FAIL_MESSAGE);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Submit ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };

  const { columns, rows } = authorsTableData(tableData, handleEdit);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  {tableName}
                </MDTypography>
                <Button
                  variant="contained"
                  color="white"
                  startIcon={<Icon>add</Icon>}
                  onClick={handleAddNew}
                >
                  Add New
                </Button>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  // showTotalEntries={false}
                  // noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}

      {/* Add/Edit Dialog */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>{editingItem ? `Edit ${tableName}` : `Add New ${tableName}`}</DialogTitle>
        <DialogContent dividers>
          <TextField
            fullWidth
            label="Title"
            margin="normal"
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
          />
          <TextField
            fullWidth
            label="Description"
            margin="normal"
            value={newDescription}
            onChange={(e) => setNewDescription(e.target.value)}
          />
          <FormControlLabel
            control={<Switch checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />}
            label="Active"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button style={{ color: "#fff" }} variant="contained" onClick={handleSubmit}>
            {editingItem ? "Update" : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default BuildStyles;
